<template>
  <div class="form-group">
    <div :class="hasIcon(icon)">
      <span v-if="iconDir === 'left'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
      <input
        :type="type"
        class="form-control"
        :class="getClasses(size, valid)"
        :name="name"
        :id="id"
        :value="modelValue"
        :placeholder="placeholder"
        :isRequired="isRequired"
        @input="onInput"
        :disabled="read"
        :step="step"
      />
      <p v-show="errorMessage" class="form__error">{{ errorMessage }}</p>
      <span v-if="iconDir === 'right'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: "argon-input",
  props: {
    size: {
      type: String,
      default: "default",
    },
    valid: {
      type: Boolean,
      default: false,
    },
    icon: String,
    iconDir: String,
    name: String,
    id: String,
    value: String,
    step:Number,
    modelValue: {
      type: [String, Number],
      default: "",
    },
    placeholder: String,
    type: String,
    isRequired: Boolean,
    errorMessage: {
      type: String,
      required: false
    },
    read:{
      type:Boolean,
      default:false
    }
  },
  emits:["update:modelValue"],
  methods: {
    getClasses: (size, valid) => {
      let sizeValue, isValidValue;

      sizeValue = size ? `form-control-${size}` : null;

      isValidValue = valid ? `${valid}` : "invalid";

      return `${sizeValue} ${isValidValue}`;
    },
    getIcon: (icon) => (icon ? icon : null),
    hasIcon: (icon) => (icon ? "input-group" : null),
    onInput(e){
      let value = e.target.value;
      if (this.type === 'number') {
        value = e.target.valueAsNumber || e.target.value;
        if (e.target.value === '') {
            value = '';
        }
      }
      this.$emit("update:modelValue", value)
    },
  },
};
</script>
